/// <reference types="vite/client" />
const MAPBOX_TOKEN = import.meta.env.VITE_MAPBOX_TOKEN;

export const generateMapboxUrl = (minLon: number, minLat: number, maxLon: number, maxLat: number, imgW: number, imgH: number, renderScale: number = 1, style: string = 'satellite-v9'): string => {
  return `https://api.mapbox.com/styles/v1/mapbox/${style}/static/[${minLon},${minLat},${maxLon},${maxLat}]/${imgW}x${imgH}${renderScale > 1 ? `@${renderScale}x` : ''}?access_token=${MAPBOX_TOKEN}`;
};
